export default __webpack_public_path__ + "static/image_05-09234ff17d49aca8fc418671ca7ad9fb.png";